import React from "react";

import {
    AbandonArticle,
    AddToOrder,
    Allergen,
    Back,
    CancelOrder,
    CancelOrderPMR,
    ContinueOrder,
    CustomerAccount,
    GiveUp,
    Ignore,
    Next,
    NextPDC,
    NextStep,
    No,
    NoThank,
    NoTHANKS,
    OtherPaymentMethods,
    OutOfStock,
    Payer,
    PayerPMR,
    Previous,
    PreviousStep,
    SuspendedProduct,
    Validate,
    ValidateStep,
    Yes,
} from "./SvgIcons";

export function DynamicSvgComponent({
    nameSvg,
    width,
    height,
    pointerEvents,
    opacity,
    onClick,
}: DynamicSvgComponentType): JSX.Element {
    let Component = null;

    switch (nameSvg) {
        case "validate":
            Component = (
                <Validate
                    width={width}
                    height={height}
                    pointerEvents={pointerEvents}
                    opacity={opacity}
                    onClick={onClick}
                />
            );
            break;
        case "back":
            Component = (
                <Back
                    width={width}
                    height={height}
                    pointerEvents={pointerEvents}
                    opacity={opacity}
                    onClick={onClick}
                />
            );
            break;
        case "otherPaymentMethods":
            Component = (
                <OtherPaymentMethods
                    width={width}
                    height={height}
                    pointerEvents={pointerEvents}
                    opacity={opacity}
                    onClick={onClick}
                />
            );
            break;
        case "ignore":
            Component = (
                <Ignore
                    width={width}
                    height={height}
                    pointerEvents={pointerEvents}
                    opacity={opacity}
                    onClick={onClick}
                />
            );
            break;
        case "giveUp":
            Component = (
                <GiveUp
                    width={width}
                    height={height}
                    pointerEvents={pointerEvents}
                    opacity={opacity}
                    onClick={onClick}
                />
            );
            break;
        case "allergen":
            Component = (
                <Allergen
                    width={width}
                    height={height}
                    pointerEvents={pointerEvents}
                    opacity={opacity}
                    onClick={onClick}
                />
            );
            break;
        case "customerAccount":
            Component = (
                <CustomerAccount
                    width={width}
                    height={height}
                    pointerEvents={pointerEvents}
                    opacity={opacity}
                    onClick={onClick}
                />
            );
            break;
        case "next":
            Component = (
                <Next
                    width={width}
                    height={height}
                    pointerEvents={pointerEvents}
                    opacity={opacity}
                    onClick={onClick}
                />
            );
            break;
        case "noThanks1":
            Component = (
                <NoTHANKS
                    width={width}
                    height={height}
                    pointerEvents={pointerEvents}
                    opacity={opacity}
                    onClick={onClick}
                />
            );
            break;
        case "outOfStock":
            Component = (
                <OutOfStock
                    pointerEvents={pointerEvents}
                    opacity={opacity}
                    onClick={onClick}
                />
            );
            break;
        case "payer":
            Component = (
                <Payer
                    width={width}
                    height={height}
                    pointerEvents={pointerEvents}
                    opacity={opacity}
                    onClick={onClick}
                />
            );
            break;
        case "payerPMR":
            Component = (
                <PayerPMR
                    width={width}
                    height={height}
                    pointerEvents={pointerEvents}
                    opacity={opacity}
                    onClick={onClick}
                />
            );
            break;
        case "cancelOrder":
            Component = (
                <CancelOrder
                    width={width}
                    height={height}
                    pointerEvents={pointerEvents}
                    opacity={opacity}
                    onClick={onClick}
                />
            );
            break;
        case "cancelOrderPMR":
            Component = (
                <CancelOrderPMR
                    width={width}
                    height={height}
                    pointerEvents={pointerEvents}
                    opacity={opacity}
                    onClick={onClick}
                />
            );
            break;
        case "validStep":
            Component = (
                <ValidateStep
                    width={width}
                    height={height}
                    pointerEvents={pointerEvents}
                    opacity={opacity}
                    onClick={onClick}
                />
            );
            break;
        case "nextStep":
            Component = (
                <NextStep
                    width={width}
                    height={height}
                    pointerEvents={pointerEvents}
                    opacity={opacity}
                    onClick={onClick}
                />
            );
            break;
        case "previousStep":
            Component = (
                <PreviousStep
                    width={width}
                    height={height}
                    pointerEvents={pointerEvents}
                    opacity={opacity}
                    onClick={onClick}
                />
            );
            break;
        case "abandonArticle":
            Component = (
                <AbandonArticle
                    width={width}
                    height={height}
                    pointerEvents={pointerEvents}
                    opacity={opacity}
                    onClick={onClick}
                />
            );
            break;
        case "continueOrder":
            Component = (
                <ContinueOrder
                    width={width}
                    height={height}
                    pointerEvents={pointerEvents}
                    opacity={opacity}
                    onClick={onClick}
                />
            );
            break;
        case "noThanks":
            Component = (
                <NoThank
                    width={width}
                    height={height}
                    pointerEvents={pointerEvents}
                    opacity={opacity}
                    onClick={onClick}
                />
            );
            break;
        case "oui":
            Component = (
                <Yes
                    width={width}
                    height={height}
                    pointerEvents={pointerEvents}
                    opacity={opacity}
                    onClick={onClick}
                />
            );
            break;
        case "non":
            Component = (
                <No
                    width={width}
                    height={height}
                    pointerEvents={pointerEvents}
                    opacity={opacity}
                    onClick={onClick}
                />
            );
            break;
        case "addToOrder":
            Component = (
                <AddToOrder
                    width={width}
                    height={height}
                    pointerEvents={pointerEvents}
                    opacity={opacity}
                    onClick={onClick}
                />
            );
            break;
        case "previous":
            Component = (
                <Previous
                    width={width}
                    height={height}
                    pointerEvents={pointerEvents}
                    opacity={opacity}
                    onClick={onClick}
                />
            );
            break;
        case "nextPDC":
            Component = (
                <NextPDC
                    width={width}
                    height={height}
                    pointerEvents={pointerEvents}
                    opacity={opacity}
                    onClick={onClick}
                />
            );
            break;
        case "suspendedProduct":
            Component = (
                <SuspendedProduct
                    pointerEvents={pointerEvents}
                    opacity={opacity}
                    onClick={onClick}
                />
            );
            break;

        default:
            Component = <div></div>;
            break;
    }
    return Component;
}
